import React from 'react';
import { IconProps } from '../types/types';

const NZDCHF: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <circle cx={14.33} cy={14.33} r={13.83} stroke="#fff" />
        <mask
            id="nzdchf_svg__a"
            style={{
                maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={29}
            height={29}
        >
            <path d="M14.33 27.91c7.5 0 13.58-6.08 13.58-13.58S21.83.75 14.33.75.75 6.83.75 14.33s6.08 13.58 13.58 13.58Z" fill="#F0F0F0" stroke="#fff" strokeWidth={0.5} />
        </mask>
        <g mask="url(#nzdchf_svg__a)">
            <path d="M14-3v1.681L7.379 1.993H14v4.992H7.379L14 10.348V12.13H10.842l-9.32-4.687v4.687h-5.043V7.444l-9.321 4.687H-16V32h60V-3H14ZM1.521-3v4.585L10.64-3H1.52Z" fill="#1A237B" />
            <path
                d="M14-3 4.015 1.993h-2.24L11.757-3h-1.12L1.52 1.585V-3H.502v6.012h13.497v-1.02H7.378l6.621-3.31V-3ZM4.22 6.018H.502V12.13h1.019V7.444l9.32 4.687H14v-.102L4.016 6.985h2.241L14 10.908v-.56L7.378 6.985h6.621v-.967H4.221Z"
                fill="#fff"
            />
            <path d="M14-3h-2.242L1.775 1.993h2.241L14-3ZM4.018 6.985 14 12.03v-1.12L6.259 6.984H4.018Z" fill="#BD0034" />
            <path d="M-2.503-3V3.012H-16v3.005h13.497v6.114H.503V6.017H14V3.012H.503V-3h-3.006Z" fill="#BD0034" />
            <path d="M25.664 7.24h1.63l.51-1.58.509 1.58h1.63l-1.325.917.51 1.58-1.325-.968-1.324.968.51-1.58-1.325-.917Z" fill="#fff" />
            <path d="M26.377 7.444h1.07l.356-1.019.306 1.019h1.12l-.866.662.306 1.02-.866-.663-.866.662.306-1.019-.866-.662Z" fill="#BD0034" />
            <path d="M19.145 13.761h1.63l.509-1.528.51 1.528h1.629l-1.324.968.509 1.58-1.324-.968-1.325.968.51-1.58-1.325-.968Z" fill="#fff" />
            <path d="M19.857 14.016h1.07l.357-1.019.305 1.019h1.12l-.916.662.356 1.02-.865-.663-.866.662.305-1.019-.866-.662Z" fill="#BD0034" />
            <path d="M25.408 24.103h1.834l.56-1.732.56 1.732h1.834l-1.477 1.07.56 1.732-1.477-1.07-1.477 1.07.56-1.732-1.477-1.07Z" fill="#fff" />
            <path d="M26.225 24.358h1.222l.357-1.12.356 1.12h1.223l-.968.713.356 1.121-.967-.713-.968.713.356-1.12-.967-.714Z" fill="#BD0034" />
        </g>
        <circle cx={26.333} cy={28.167} r={13.581} fill="#fff" stroke="#fff" strokeWidth={0.5} />
        <path d="M26.331 41.498c7.363 0 13.332-5.968 13.332-13.331 0-7.363-5.969-13.332-13.332-13.332C18.97 14.835 13 20.805 13 28.167c0 7.363 5.969 13.331 13.331 13.331Z" fill="red" />
        <path d="M24.004 22h3.75v4.375h4.375v3.75h-4.375V34.5h-3.75v-4.375h-4.375v-3.75h4.375V22Z" fill="#fff" />
    </svg>
);

export default NZDCHF;
